import * as types from '../common/types'
import createReducer from './createReducer'
import { cloneDeep, get, isArray, omit, pullAt, set } from 'lodash'

const initialState = {}

export const forms = createReducer(initialState, {
  [types.ADD_FORM](state, { data, fields, initial, formId }) {
    return {
      ...state,
      [formId]: {
        errors: [],
        fields: { ...initial, ...fields },
        fieldValidation: {},
        files: {},
        formState: {},
        initial: { ...initial },
        isSubmitting: false,
        validationErrors: {},
        ...data,
      },
    }
  },
  [types.SET_INITIAL_FORM_FIELDS](state, { data, formId }) {
    return {
      ...state,
      [formId]: {
        ...state[formId],
        initial: data,
      },
    }
  },
  [types.REMOVE_FORM](state, { formId }) {
    return omit(state, [formId])
  },
  [types.CLEAR_FORM_FIELDS](state, { fields, formId }) {
    return {
      ...state,
      [formId]: {
        ...state[formId],
        fields: omit(state[formId].fields, fields),
      },
    }
  },
  [types.CLEAR_FORM_ARRAY_FIELD](state, { key, indexes, formId }) {
    const fields = cloneDeep(state[formId].fields)
    const array = get(fields, key)
    pullAt(array, indexes)
    set(fields, key, array)
    return {
      ...state,
      [formId]: {
        ...state[formId],
        fields,
      },
    }
  },
  [types.CLEAR_FORM](state, { formId }) {
    return {
      ...state,
      [formId]: {
        ...state[formId],
        fields: {},
        formState: {},
        initial: {},
      },
    }
  },
  [types.TOGGLE_FORM_SUBMITTING](state, { formId }) {
    return {
      ...state,
      [formId]: {
        ...state[formId],
        isSubmitting: state[formId] && !state[formId].isSubmitting,
      },
    }
  },
  [types.UPDATE_FORM_ERRORS](state, { errors, formId }) {
    const errorsList = isArray(errors) ? errors : [errors]
    return {
      ...state,
      [formId]: {
        ...state[formId],
        errors: errorsList,
      },
    }
  },
  [types.UPDATE_FORM_VALIDATION_ERRORS](state, { errors, formId }) {
    return {
      ...state,
      [formId]: {
        ...state[formId],
        validationErrors: errors || {},
      },
    }
  },
  [types.SET_FIELD_VALIDATION](
    state,
    { key, label, dependsOn, relatedKeys, required, validationTypes, formId }
  ) {
    const typesArray = isArray(validationTypes)
      ? validationTypes
      : [validationTypes]
    const currentForm = state[formId]
    return {
      ...state,
      [formId]: {
        ...currentForm,
        fieldValidation: {
          ...(currentForm ? currentForm.fieldValidation : {}),
          [key]: {
            label,
            dependsOn,
            relatedKeys,
            required,
            validationTypes: validationTypes ? typesArray : [],
          },
        },
      },
    }
  },
  [types.CLEAR_FIELD_VALIDATION](state, { keys, formId }) {
    if (!state[formId]) {
      return state
    }
    return {
      ...state,
      [formId]: {
        ...state[formId],
        fieldValidation: omit(state[formId].fieldValidation, keys),
        validationErrors: omit(state[formId].validationErrors, keys),
      },
    }
  },
  [types.SET_FORM_STATE](state, { key, value, formId }) {
    const formState = cloneDeep(state[formId] ? state[formId].formState : {})
    set(formState, key, value)

    return {
      ...state,
      [formId]: {
        ...state[formId],
        formState,
      },
    }
  },
  [types.SET_FORM_FIELD](state, { key, value, formId }) {
    if (!key) return state
    if (key.match(/location/)) {
      return {
        ...state,
        [formId]: {
          ...state[formId],
          fields: {
            ...state[formId].fields,
            [key]: value,
          },
        },
      }
    }
    const fields = cloneDeep(state[formId].fields)
    set(fields, key, value)

    return {
      ...state,
      [formId]: {
        ...state[formId],
        fields,
      },
    }
  },
  [types.ADD_FORM_FILE](state, { key, file, uri, formId }) {
    return {
      ...state,
      [formId]: {
        ...state[formId],
        files: {
          ...state[formId].files,
          [key]: {
            file,
            uri,
          },
        },
      },
    }
  },
})
